import clsx from "clsx";
import React, { useRef, useEffect, useState } from "react";
import CustomLink from "../../utils/customLink";

function MobileLinkGroup({ index, value, openLink, handleToggleCollapse, expanded }) {
    const contentRef = useRef(null);
    const [maxHeight, setMaxHeight] = useState("0px");

    useEffect(() => {
        if (expanded && contentRef.current) {
            setMaxHeight(`${contentRef.current.scrollHeight}px`);
        } else {
            setMaxHeight("0px");
        }
    }, [expanded]);

    return (
        <div className="mb-4" key={index}>
            <div
                className="flex flex-row justify-between text-primary_color text-xs py-2 border-solid border-b border-accent_color2 cursor-pointer"
                onClick={() => handleToggleCollapse(index)}
            >
                <h2
                    id={`${index}`}
                    className="text-xs uppercase"
                    aria-expanded={expanded}
                    aria-controls={`collapse${index}`}
                >
                    {value.heading}
                </h2>
                <i
                    className={clsx("pi text-accent_color2 transition-transform duration-300", {
                        "pi-angle-down": !expanded,
                        "pi-angle-down rotate-180": expanded,
                    })}
                ></i>
            </div>

            <div
                id={`collapse${index}`}
                className="overflow-hidden transition-all duration-500 ease-in-out"
                style={{ maxHeight }}
                aria-labelledby={`collapse${index}`}
                ref={contentRef}
            >
                <ul className="mt-2 select-none text-start">
                    {value.contents &&
                        value.contents.map((v) => (
                            <CustomLink
                                to={openLink(v.content_reference)}
                                type={v.type}
                                key={v.heading}
                            >
                                <li className="cursor-pointer text-accent_color2 text-xs py-2 uppercase footer-links">
                                    {v.heading}
                                </li>
                            </CustomLink>
                        ))}
                </ul>
            </div>
        </div>
    );
}

export default MobileLinkGroup;
